import React, { Key, useState } from 'react';
import { Space } from 'antd';
import styles from './index.module.scss';

// 定义组件属性接口
interface SwitchButtonProps {
  options: { label: string; value: Key }[];
  defaultValue: Key;
  onChange?: (value: Key) => void;
  className?: string;
}

// 定义组件
const SwitchButton: React.FC<SwitchButtonProps> = ({ defaultValue, options, onChange, className }) => {
  const [activeKey, setActiveKey] = useState<Key>(defaultValue);

  const handleDateChange = (value: Key) => {
    setActiveKey(value);
    onChange?.(value);
  };

  return (
    <Space size={8} className={className}>
      {options.map((item, index) => (
        <div
          key={index}
          className={`${styles.switchBtn} ${activeKey === item.value && styles.active}`}
          onClick={() => handleDateChange(item.value)}
        >
          {item.label}
        </div>
      ))}
    </Space>
  );
};

export default SwitchButton;
